module.exports = __webpack_public_path__ + "img/mapbk.b6e57cb6.png";